import "@babel/polyfill"
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VeeValidate from 'vee-validate'
import VueAnalytics from 'vue-analytics'
import FocusVisible from 'vue-focus-visible'
import getFormSchema from './utils/helpers/getFormSchema'
import messages from './translations'
import GA_CONFIG from './utils/mappings/gaConfig'
import { templates } from './templates'

import SmartForm from './components/SmartForm'

import sFormTextarea from './components/form/s-form-textarea'
import sFormGroup from './components/form/s-form-group'
import sInputGroup from './components/fieldGroups/inputGroup'
import sSelectGroup from './components/fieldGroups/selectGroup'
//import sRadioGroup from "./components/fieldGroups/radioGroup"
import sCheckboxGroup from './components/fieldGroups/checkBoxGroup'
import sCheckboxListGroup from './components/fieldGroups/checkBoxListGroup'
import sTextareaGroup from './components/fieldGroups/textareaGroup'

Vue.use(VueI18n)
Vue.use(FocusVisible)

Vue.config.productionTip = false

const i18n = new VueI18n({
    fallbackLocale: 'en-us',
    locale: 'en-us', // set locale
    messages // set locale messages
})

i18n.locale = "en-us"

Vue.use(VeeValidate, {
    events: '',
    inject: true,
    i18nRootKey: 'validation', // customize the root path for validation messages.
    i18n,
    dictionary: {
        "en-us": messages["en-us"].message.validation,
        "fr": messages["fr"].message.validation,
        "de": messages["de"].message.validation,
        "cs": messages["cs"].message.validation,
        "it": messages["it"].message.validation,
        "ja": messages["ja"].message.validation,
        "ko": messages["ko"].message.validation,
        "nl": messages["nl"].message.validation,
        "no": messages["no"].message.validation,
        "pt": messages["pt"].message.validation,
        "ru": messages["ru"].message.validation,
        "tr": messages["tr"].message.validation,
        "zh": messages["zh"].message.validation
    }
});

/**
 * Load GA tracking if analytics id exists in map
 */
let ga_host = ""
if(GA_CONFIG.hasOwnProperty(document.location.hostname) && typeof ga === 'function'){
    ga_host = document.location.hostname;
    Vue.use(VueAnalytics, {
        id: GA_CONFIG[document.location.hostname].id,
        checkDuplicatedScript: true
    })
}

window.CTX_SmartForms = window.CTX_SmartForms || {};

window.CTX_SmartForms = {
    instances: null,
    forms: [],
    initForm: function(id){
        var self = this,
            formEl = document.getElementById(id),
            template = templates[formEl.dataset.template],
            formType = (formEl.dataset.formtype !== undefined) ? formEl.dataset.formtype : "SmartForm"
        formEl.dataset.rules = (formEl.dataset.rules) ? formEl.dataset.rules.replace(/'/g, '"') : "{}"
        formEl.dataset.success = (template !== undefined)
        formEl.dataset.id = id
        formEl.dataset.ga_host = ga_host
        self.forms[id] =
            new Vue({
                i18n,
                el: "#"+id,
                components: {
                    SmartForm,
                    sFormGroup,
                    sFormTextarea,
                    sInputGroup,
                    sCheckboxListGroup,
                    sCheckboxGroup,
                    sSelectGroup,
                    sTextareaGroup
                    //sRadioGroup
                },
                data(){
                    return {
                        schema: {},
                        debugMode: (process.env.VUE_APP_DEBUG_FORM === 'true')
                    }
                },
                created(){
                    //set the language per the domain language map
                    this.domainLanguageCheck()

                    this.schema = getFormSchema(this.$i18n.locale, formType)

                    //multi select needs to be an object, we are loading as a string
                    //TODO Brian
                    // Please review, PPI doesn't apply to PrefCenter or OptOut forms
                    if(formEl.dataset.ppi){
                        this.schema.fields.Primary_Product_Interest__c = formEl.dataset.ppi.split(";")
                    }else{
                        this.schema.fields.Primary_Product_Interest__c = ''
                    }
                },
                methods:{
                    domainLanguageCheck(){
                        // if locale set, ignore domain map
                        if(formEl.dataset.locale){
                            this.$i18n.locale = formEl.dataset.locale
                            return
                        }

                        let langCheck = document.getElementsByTagName("html")[0].hasAttribute("lang");
                        if (langCheck) {
                            let lang = document.getElementsByTagName("html")[0].getAttribute("lang");
                            if (lang !== 'en') {

                                // make sure we have a matching translation
                                if(Object.keys(messages).includes(lang)){
                                    this.$i18n.locale = lang;
                                }

                            }
                        }
                    }
                },
                template: "<smart-form :config='"+JSON.stringify(formEl.dataset)+"' :schema='schema' :debugMode='debugMode'>"+template+"</smart-form>"
            })
    },
    init: function(){
        var self = this;
        self.instances = document.getElementsByClassName("py-smart-form");
        if(self.instances.length > 0){
            for(var i = 0; i < self.instances.length; i++){
                self.initForm(self.instances[i].getAttribute("id"));
            }
        }
        //dispatch form loaded event
        let event, eventText = 'CTX_SmartForms.formsLoaded';
        if(typeof(Event) === 'function') {
            event = new Event(eventText, {bubbles: true});
        }else{
            event = document.createEvent('Event');
            event.initEvent(eventText, true, true);
        }

        //set interval to fire event continuously to allow for better event listening
        dispatchLoadingEvent()
        let loadingInterval = setInterval(dispatchLoadingEvent, 250)

        //clear interval when window has loaded
        window.onload = function() {
            clearInterval(loadingInterval)
        }

        function dispatchLoadingEvent(){
            document.dispatchEvent(event);
        }

    }
}
/*
TODO: make sure this only fires once
 */
window.CTX_SmartForms.init();